import { RankingWeights } from '@/src/types/aiRecommendation'

export { buildProcessedFlightsIndex } from './ranking/public'
export type {
    BilingualReasons,
    ComparisonInfo, DealLabel, NormalizedScores,
    ProcessedFlightMetrics,
    ProcessedFlightsIndex,
    ProcessedFlightsResult,
    RankingContext
} from './ranking/public'

export const MAX_INPUT_LENGTH = 150
export const SHOW_SMART_METRICS = false

export const DEFAULT_WEIGHTS: RankingWeights = {
    priceWeight: 0.38,
    durationWeight: 0.28,
    layoverWeight: 0.19,
    departureWeight: 0.10,
    arrivalWeight: 0.05
}
